import '../modules/slider-gallery-brands';
import '../modules/slider-photos';
import '../modules/slider-categories';
import '../modules/video';
import 'magnific-popup';
import 'jquery-touchswipe';

(function () {
  var magnificPopup = $.magnificPopup.instance;
  $('a.slider-photo__item, .js-popup-image').click(function () {
    setTimeout(function () {
      $('.mfp-container').swipe({
        swipeLeft: function () {
          magnificPopup.next();
        },
        swipeRight: function () {
          magnificPopup.prev();
        }
      });
    }, 500);
  });
}.call(this));

if ($('.slider-photo__content').length) {
  $('.slider-photo__content').magnificPopup({
    delegate: 'a',
    type: 'image',
    gallery: {
      enabled: true
    }
  });
}